import { Button } from 'component/Button/Button'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'

interface ComboCartIndicatorProps {
  onOpen?: () => void
}

export const ComboCartIndicator = observer(({ onOpen }: ComboCartIndicatorProps) => {
    const demo = useDemo()
    const { stand } = demo

    const onClick = useLatestCallback(() => {
      if (onOpen) onOpen()
    })

    const icon = <Icon name="shopping_bag" size={16} />
    return (
      <Button xl compact action={onClick} outline={stand} icon={icon}>
        {comboCartStore.count}
      </Button>
    )
  },
)
